import React from 'react';
import PropTypes from 'prop-types';
import CollapsibleStyles from './collapsibleStyles';

const Collapsible = props => {
  return (
    <CollapsibleStyles visible={props.visible} applyBelow={props.applyBelow}>
      {props.children}
    </CollapsibleStyles>
  );
};

Collapsible.propTypes = {
  visible: PropTypes.bool,
  applyBelow: PropTypes.number,
  children: PropTypes.node.isRequired,
};

Collapsible.defaultProps = {
  visible: false,
  applyBelow: undefined,
};

export default Collapsible;
